import { cloneDeep } from 'lodash';
import axios from 'axios';
import api from '@src/api';

export const state = {
  allRecipes: [],
  isLoadingRecipes: false,
  recipeDetails: {},
  recipeFilterOpts: {},
  selectedRecipeFilterOpts: null,
  selectedRecipe: null,
  selectedRecipeStep: null,
  updatedNutritionValues: [],
  clearRecipeFilters: false,
  hasUnsavedRecipeChanges: false,
  discardRecipeChanges: false,
  showRecipeArchivedOverlay: true,
  recipesFilter: {},
};

export const getters = {};

export const mutations = {
  setAllRecipes(state, value) {
    state.allRecipes = value;
  },
  setRecipeFilterOpts(state, value) {
    state.recipeFilterOpts = value;
  },
  setIsLoadingRecipes(state, value) {
    state.isLoadingRecipes = value;
  },
  setClearRecipeFilters(state, value) {
    state.clearRecipeFilters = value;
  },
  setFilterTrainerOnlyRecipes(state, value) {
    if (
      state.allRecipes &&
      state.allRecipes.hits &&
      state.allRecipes.hits.length &&
      value
    ) {
      const allRecipes = cloneDeep(state.allRecipes.hits);
      const trainerRecipes = allRecipes.filter(
        (recipe) => value !== recipe.editabilityStatus.locked
      );
      state.allRecipes.hits = trainerRecipes;
    }
  },
  setFilterOrgOnlyRecipes(state, value) {
    if (
      state.allRecipes &&
      state.allRecipes.hits &&
      state.allRecipes.hits.length &&
      value
    ) {
      const allRecipes = cloneDeep(state.allRecipes.hits);
      const orgRecipes = allRecipes.filter(
        (recipe) => value === recipe.editabilityStatus.locked
      );
      state.allRecipes.hits = orgRecipes;
    }
  },
  setSelectedRecipeFilterOpts(state, value) {
    const initObj = {};
    if (value === 'reset') {
      Object.keys(state.recipeFilterOpts).forEach((group) => {
        initObj[group] = buildFilterOpts(group);
      });
      state.selectedRecipeFilterOpts = initObj;
    } else if (value.opt && value.group) {
      if (
        state.selectedRecipeFilterOpts[value.group] &&
        !state.selectedRecipeFilterOpts[value.group].includes(value.opt.value)
      ) {
        state.selectedRecipeFilterOpts[value.group].push(value.opt.value);
      } else {
        const i = state.selectedRecipeFilterOpts[value.group].findIndex(
          (item) => item === value.opt.value
        );
        state.selectedRecipeFilterOpts[value.group].splice(i, 1);
      }
    } else {
      Object.keys(value).forEach((group) => {
        initObj[group] = buildFilterOpts(group);
      });
      state.selectedRecipeFilterOpts = initObj;
    }
  },
  setRecipeDetails(state, value) {
    state.selectedRecipe = value;
    state.recipeDetails = value;
  },
  setCreateRecipe(state, value) {
    const allRecipes = cloneDeep(state.allRecipes);
    allRecipes.hits.unshift(value);
    state.allRecipes = allRecipes;
  },
  setSelectedRecipe(state, value) {
    state.selectedRecipe = value;
  },
  setUpdateRecipeTitle(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.title = value;
    recipeClone.landingPageTitle = value;
    state.selectedRecipe = recipeClone;
  },
  setUpdateRecipeItem(state, value) {
    if (state.allRecipes && state.allRecipes.hits) {
      const allRecipes = cloneDeep(state.allRecipes);
      const i = allRecipes.hits.findIndex((item) => item.id === value.id);
      allRecipes.hits[i] = value;
      state.allRecipes = allRecipes;
    }
  },
  setUpdateRecipeDescription(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.description = value.description;
    recipeClone.landingPageDescription = value.description;
    state.selectedRecipe = recipeClone;
  },
  setUpdateRecipeType(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.type = value;
    state.selectedRecipe = recipeClone;
  },
  setUpdateRecipeStatus(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    switch (value) {
      case 'draft':
        recipeClone.draft = true;
        recipeClone.archived = false;
        break;
      case 'publish':
        recipeClone.draft = false;
        recipeClone.archived = false;
        break;
      case 'archive':
        recipeClone.draft = false;
        recipeClone.archived = true;
        break;
    }
    state.selectedRecipe = recipeClone;
  },
  setUpdateRecipeCookHours(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.totalTime = value;
    state.selectedRecipe = recipeClone;
  },
  setUpdateRecipeCookMinutes(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.totalTime = value;
    state.selectedRecipe = recipeClone;
  },
  setUpdateRecipeMealtimes(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    if (
      recipeClone.mealTimes.some((mealtime) => mealtime.name === value.name)
    ) {
      recipeClone.mealTimes = recipeClone.mealTimes.filter(
        (mealtime) => mealtime.name !== value.name
      );
    } else {
      recipeClone.mealTimes.push(value);
    }
    state.selectedRecipe = recipeClone;
  },
  setCreateRecipeNutritionUnits(state, value) {
    const nutritionValuesClone = cloneDeep(state.updatedNutritionValues);

    if (state.updatedNutritionValues.length) {
      const i = state.updatedNutritionValues.findIndex(
        (item) => item.code === value.code
      );

      if (i > -1) {
        if (value.value === 0 || value.value === '') {
          nutritionValuesClone.splice(i, 1);
          state.updatedNutritionValues = nutritionValuesClone;
        } else {
          nutritionValuesClone[i] = value;
          state.updatedNutritionValues = nutritionValuesClone;
        }
      } else {
        nutritionValuesClone.push(value);
        state.updatedNutritionValues = nutritionValuesClone;
      }
    } else {
      nutritionValuesClone.push(value);
      state.updatedNutritionValues = nutritionValuesClone;
    }
  },
  setUpdateRecipeNutritionUnits(state, value) {
    const selectedRecipeClone = cloneDeep(state.selectedRecipe);

    if (selectedRecipeClone.nutritionDigest.length) {
      const i = selectedRecipeClone.nutritionDigest.findIndex(
        (item) => item.code === value.code
      );

      if (i > -1) {
        if (value.value === 0 || value.value === '') {
          selectedRecipeClone.nutritionDigest.splice(i, 1);
          state.selectedRecipe = selectedRecipeClone;
        } else {
          selectedRecipeClone.nutritionDigest[i] = value;
          state.selectedRecipe = selectedRecipeClone;
        }
      } else {
        selectedRecipeClone.nutritionDigest.push(value);
        state.selectedRecipe = selectedRecipeClone;
      }
    } else {
      selectedRecipeClone.nutritionDigest.push(value);
      state.selectedRecipe = selectedRecipeClone;
    }
  },
  setUpdatedNutritionValues(state, value) {
    state.updatedNutritionValues = value;
  },
  setUpdateRecipeCalories(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.calories = value ? parseInt(value) : null;
    state.selectedRecipe = recipeClone;
  },
  setUpdateRecipeServings(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.serves = value;
    state.selectedRecipe = recipeClone;
  },
  setUpdateRecipeServingsText(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.servingSizeText = value;
    state.selectedRecipe = recipeClone;
  },
  setClearRecipeNutritionUnits(state) {
    state.updatedNutritionValues = [];
  },
  setRecipeNutritionDigest(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.nutritionDigest = value;
    state.selectedRecipe = recipeClone;
  },
  setRecipeDetailsNutritionDigest(state, value) {
    const recipeDetails = cloneDeep(state.recipeDetails);
    recipeDetails.nutritionDigest = value;
    state.recipeDetails = recipeDetails;
  },
  setSelectedRecipeStep(state, value) {
    state.selectedRecipeStep = value;
  },
  setAddInstructionStep(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.instructions.push(value);
    state.selectedRecipe = recipeClone;
  },
  setAddIngredientStep(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.ingredients.push(value);
    state.selectedRecipe = recipeClone;
  },
  setUpdateInstructionStep(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.instructions[value.index] = value.step;
    state.selectedRecipe = recipeClone;
  },
  setUpdateIngredientStep(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.ingredients[value.index] = value.step;
    state.selectedRecipe = recipeClone;
  },
  setRemoveInstructionStep(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.instructions.splice(value.index, 1);
    state.selectedRecipe = recipeClone;
  },
  setRemoveIngredientStep(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.ingredients.splice(value, 1);
    state.selectedRecipe = recipeClone;
  },
  setMoveInstructionStep(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    const selectedStep = recipeClone.instructions[value.index];
    selectedStep.step = value.futureIndex + 1;

    if (value.direction === 'up') {
      recipeClone.instructions.forEach((step) => {
        if (
          step.id !== selectedStep.id &&
          step.step >= selectedStep.step &&
          step.step < recipeClone.instructions.length
        ) {
          step.step++;
        }
      });
    } else {
      recipeClone.instructions.forEach((step) => {
        if (
          step.id !== selectedStep.id &&
          step.step <= selectedStep.step &&
          step.step > 1
        ) {
          step.step--;
        }
      });
    }

    recipeClone.instructions = swapSteps(
      recipeClone.instructions,
      value.index,
      value.futureIndex
    );
    state.selectedRecipe = recipeClone;
  },
  setMoveIngredientStep(state, value) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    const selectedStep = recipeClone.ingredients[value.index];
    selectedStep.sortOrder = value.futureIndex + 1;

    if (value.direction === 'up') {
      recipeClone.ingredients.forEach((step) => {
        if (
          step.id !== selectedStep.id &&
          step.sortOrder >= selectedStep.sortOrder &&
          step.sortOrder < recipeClone.ingredients.length
        ) {
          step.sortOrder++;
        }
      });
    } else {
      recipeClone.ingredients.forEach((step) => {
        if (
          step.id !== selectedStep.id &&
          step.sortOrder <= selectedStep.sortOrder &&
          step.sortOrder > 1
        ) {
          step.sortOrder--;
        }
      });
    }

    recipeClone.ingredients = swapSteps(
      recipeClone.ingredients,
      value.index,
      value.futureIndex
    );
    state.selectedRecipe = recipeClone;
  },
  setToggleRecipeFlaggedStatus(state) {
    const recipeClone = cloneDeep(state.selectedRecipe);
    recipeClone.flagged = !state.selectedRecipe.flagged;
    state.selectedRecipe = recipeClone;
  },
  setHasUnsavedRecipeChanges(state, value) {
    state.hasUnsavedRecipeChanges = value;
  },
  setDiscardRecipeChanges(state, value) {
    state.discardRecipeChanges = value;
  },
  setShowRecipeArchivedOverlay(state, value) {
    state.showRecipeArchivedOverlay = value;
  },
  setRecipesFilter(state, value) {
    state.recipesFilter = value;
  },
};

export const actions = {
  init({ state, dispatch, rootState }) {
    if (rootState.auth && rootState.auth.currentUser) {
      dispatch('getRecipeFilterOpts');
      dispatch('getAllRecipes');
    }
  },
  getAllRecipes(ctx, { resultsPerPage = 25, pageOffset = 0 } = {}) {
    const queryParams = {
      ...state.selectedRecipeFilterOpts,
      from: resultsPerPage * pageOffset,
      to: resultsPerPage * pageOffset + resultsPerPage,
    };

    return axios
      .put(api.URL_GET_ALL_RECIPES, queryParams)
      .then((res) => {
        ctx.commit('setAllRecipes', res.data);
        return res;
      })
      .catch((err) => {
        console.error(err);
        ctx.commit('setAllRecipes', []);
        return null;
      });
  },
  getRecipe(ctx, { recipeId }) {
    const url = api.URL_GET_RECIPE.replace(':recipeID', recipeId);

    return axios
      .get(url)
      .then((res) => {
        ctx.commit('setRecipeDetails', res.data);
        return res.data;
      })
      .catch((err) => {
        console.warn(err);
      });
  },
  getRecipeFilterOpts(ctx) {
    const url = api.URL_GET_RECIPE_FILTER_OPTS;

    return axios
      .get(url)
      .then((res) => {
        ctx.commit('setRecipeFilterOpts', res.data.inputOptions);
        ctx.commit('setSelectedRecipeFilterOpts', res.data.inputOptions);
        return res.data;
      })
      .catch((err) => {
        console.warn(err);
      });
  },
  createRecipe(ctx, recipeObj) {
    const url = api.URL_CREATE_UPDATE_RECIPE.replace(
      ':recipeID',
      recipeObj.recipe.id
    );

    recipeObj.recipe.ingredients = filterPlaceholderIngredients(
      recipeObj.recipe.ingredients
    );
    recipeObj.recipe.instructions = filterPlaceholderInstructions(
      recipeObj.recipe.instructions
    );

    return axios
      .put(url, recipeObj)
      .then((res) => {
        if (res.data.error) {
          console.error('Error: ', res.data.error);
        } else {
          if (ctx.state.updatedNutritionValues.length) {
            recipeObj.recipe.id = res.data.id;
            ctx.dispatch('updateRecipeNutritionUnits', recipeObj);
          }

          ctx.commit('setCreateRecipe', res.data);
          return res.data;
        }
      })
      .catch((err) => {
        console.warn(err);
      });
  },
  updateRecipe(ctx, recipeObj) {
    const url = api.URL_CREATE_UPDATE_RECIPE.replace(
      ':recipeID',
      recipeObj.recipe.id
    );

    if (ctx.state.updatedNutritionValues.length) {
      ctx.dispatch('updateRecipeNutritionUnits', recipeObj);
    }

    return axios
      .put(url, recipeObj)
      .then((res) => {
        ctx.commit('setUpdateRecipeItem', res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  updateRecipeNutritionUnits(ctx, recipeObj) {
    const url = api.URL_UPDATE_RECIPE_NUTRITION_UNITS.replace(
      ':recipeID',
      recipeObj.recipe.id
    );

    return axios
      .put(url, { nutritionValues: ctx.state.updatedNutritionValues })
      .then((res) => {
        ctx.commit('setUpdateRecipeItem', res.data);
        ctx.commit('setClearRecipeNutritionUnits');
      })
      .catch((err) => {
        console.log(err);
      });
  },
};

// Private Helpers

function swapSteps(arr, index1, index2) {
  [arr[index1], arr[index2]] = [arr[index2], arr[index1]];
  return arr;
}

function buildFilterOpts(group) {
  switch (group) {
    case 'Diet Requirements':
    case 'Tag Requirements':
    case 'Health Requirements':
    case 'Meal Time Requirements':
    case 'Recipe Type':
    case 'Excluded Foods':
    case 'Kitchen Requirements':
      return [];
    case 'Query String':
    case 'Max Ingredient Count':
      return '';
    case 'to':
    case 'from':
      return 0;
    case 'Max Cooking Time':
      return { low: null, high: null };
    case 'Calorie Range':
    case 'Nutrient Requirements':
      return {};
  }
}

function filterPlaceholderIngredients(ingredients) {
  return ingredients.filter((ingredient) => {
    if (
      Object.prototype.hasOwnProperty.call(ingredient, 'count') &&
      Object.prototype.hasOwnProperty.call(ingredient, 'ingredientId') &&
      Object.prototype.hasOwnProperty.call(ingredient, 'preparation')
    ) {
      return ingredient;
    }
  });
}

function filterPlaceholderInstructions(instructions) {
  return instructions.filter((instruction) => instruction.description !== '');
}
